import type {SidebarLink} from '../types/sidebar-types'

interface HandleNavItemClickParams {
  linkItem: SidebarLink
  onSelectLink: (linkItem: SidebarLink) => void
  sendAnalyticsEvent: (category: string, action: string, label?: Record<string, unknown>) => void
}

/// Handles the click on a navigation item, sending an analytics event and updating the query if it's a soft navigation.
export function getHandlerNavItemClick({linkItem, onSelectLink, sendAnalyticsEvent}: HandleNavItemClickParams) {
  const tags = linkItem.source === 'predefined' ? {id: linkItem.id} : {shortcut: true}

  return (event: React.MouseEvent) => {
    sendAnalyticsEvent('repos-list.sidebar', 'SIDEBAR_PICKER', tags)
    if (canSoftNavigate(event)) {
      onSelectLink(linkItem)
      event.preventDefault()
    }
  }
}

/// Detects whether the click is handled on a new window or tab, thus we should ignore it on this instance.
function canSoftNavigate(event: React.MouseEvent) {
  // eslint-disable-next-line @github-ui/ui-commands/no-manual-shortcut-logic -- Handle locally unless user is opening on a new tab
  return !event.ctrlKey && !event.metaKey && !event.shiftKey && event.button === 0
}
